var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.905,
    height: 13.905,
    viewBox: "0 0 13.905 13.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-up-right",
    "data-name": "Icon feather-arrow-up-right",
    transform: "translate(6.952 -13.789) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95962",
    "data-name": "Path 95962",
    d: "M10.5,10.5h8.332v8.332",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBackArrow);
export default __webpack_public_path__ + "static/media/header_back_arrow.c04df15846cf825522505b02fcc8b880.svg";
export { ForwardRef as ReactComponent };